import { ProductViewConfigurator } from '~/types/configurator';

export default {
    controls: [
        {
            key: 'pattern',
            keyLabel: 'pattern',
            label: 'Pattern',
            displayAsImages: true,
            choices: [
                {
                    label: 'Less Depresso',
                    value: 'less-depresso',
                    imageUrl: '/images/stocked-stickers/less-depresso.webp',
                },
                {
                    label: 'Cat in a Cup',
                    value: 'cat-in-a-cup',
                    imageUrl: '/images/stocked-stickers/cat-in-a-cup.webp',
                },
                {
                    label: 'Teddy Bear',
                    value: 'teddy-bear',
                    imageUrl: '/images/stocked-stickers/teddy-bear.webp',
                },
                {
                    label: 'Iced Coffee',
                    value: 'iced-coffee',
                    imageUrl: '/images/stocked-stickers/iced-coffee.webp',
                },
                {
                    label: 'Happy Camper',
                    value: 'happy-camper',
                    imageUrl: '/images/stocked-stickers/happy-camper.webp',
                },
                {
                    label: 'Coffee Lovers Club',
                    value: 'coffee-lovers-club',
                    imageUrl:
                        '/images/stocked-stickers/coffee-lovers-club.webp',
                },
                {
                    label: 'Blonde Roasts',
                    value: 'blonde-roasts',
                    imageUrl: '/images/stocked-stickers/blonde-roasts.webp',
                },
                {
                    label: 'Thirsty Skull',
                    value: 'thirsty-skull',
                    imageUrl: '/images/stocked-stickers/thirsty-skull.webp',
                },
                {
                    label: 'Hug in a Mug',
                    value: 'hug-in-a-mug',
                    imageUrl: '/images/stocked-stickers/hug-in-a-mug.webp',
                },
                {
                    label: 'Desert',
                    value: 'desert',
                    imageUrl: '/images/stocked-stickers/desert.webp',
                },
            ],
        },
    ],
} as ProductViewConfigurator;
